import { render, staticRenderFns } from "./BoutonGestionBarquettes.vue?vue&type=template&id=06f2eea0&"
import script from "./BoutonGestionBarquettes.vue?vue&type=script&lang=js&"
export * from "./BoutonGestionBarquettes.vue?vue&type=script&lang=js&"
import style0 from "./BoutonGestionBarquettes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f2eea0')) {
      api.createRecord('06f2eea0', component.options)
    } else {
      api.reload('06f2eea0', component.options)
    }
    module.hot.accept("./BoutonGestionBarquettes.vue?vue&type=template&id=06f2eea0&", function () {
      api.rerender('06f2eea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/BoutonGestionBarquettes.vue"
export default component.exports